import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
/* eslint-disable jsx-a11y/anchor-is-valid */
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import {filterLaundryBatchModel} from '../../../../model'
import {useCamp, useClient, useSite, useCompany} from '../../../../../central/hooks'
import {SelectModel} from '../../../../model'
import {SelectWrapper} from '../../../../../../components/UI/Form/Input'
import {ModalStartWash, ModalFinishWash, ModalOut, ModalCancel} from '../Modal'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import useTableForMaster from '../../../../hooks/useTableForMaster'
import {orderLaundryBatch} from '../../../../schema/laundryBatch'
import {useKTable} from '../../../../../../contexts/KTableProvider'
type Props = {
  getLaundryList: (e: any) => void
  formValues: any
  setFormValues: Dispatch<SetStateAction<any>>
  formValueLoading: any
  setFormValueLoading: Dispatch<SetStateAction<any>>
}
export const FormLaundryBatch: FC<Props> = ({setFormValueLoading, setFormValues}) => {
  const {currentTabItem} = useLavanderia()
  const {setClearTable} = useKTable()
  const [searching, setIsSearching] = useState<boolean>(false)
  const [showModalStart, setShowModalStart] = useState<boolean>(false)
  const [showModalFinish, setShowModalFinish] = useState<boolean>(false)
  const [showModalOut, setShowModalOut] = useState<boolean>(false)
  const [showModalCancel, setShowModalCancel] = useState<boolean>(false)
  const [company, setCompany] = useState<SelectModel[]>([])
  const [clients, setClients] = useState<SelectModel[] | any>([])
  const [sites, setSites] = useState<SelectModel[] | any>([])
  const [camps, setCamps] = useState<SelectModel[]>([])
  const {typeLaundryOrderLote, getTypeLaundryLoteList} = useTableForMaster()
  const methods = useForm({
    resolver: yupResolver(orderLaundryBatch),
  })

  const {setValue, handleSubmit, setError, reset, watch} = methods
  const {getCompanyFD} = useCompany()
  const {getClientFD} = useClient()
  const {getSiteFD} = useSite()
  const {getCampFD} = useCamp()
  const getCompanyList = async () => {
    const response = await getCompanyFD({})
    if (response.length === 1) {
      setValue('companiaId', response[0].value)
      setError('companiaId', {})
      await getClientList(response[0].value as string)
    }

    setCompany(response)
  }
  const getClientList = async (companyId: string) => {
    const response = await getClientFD({companiaId: companyId})
    if (response.length === 1) {
      setValue('clienteId', response[0].value)
      setError('clienteId', {})
      await getSiteList(response[0].value as string)
    }
    setClients(response)
  }
  const getSiteList = async (clientId: string) => {
    const response = await getSiteFD({clienteId: clientId})
    if (response.length === 1) {
      setValue('siteId', response[0].value)
      setError('siteId', {})
      await getCampList(response[0].value as string)
    }
    setSites(response)
  }
  const getCampList = async (siteId: string) => {
    const response = await getCampFD({siteId: siteId})
    if (response.length === 1) {
      setValue('campamentoId', response[0].value)
      setError('campamentoId', {})
    }
    setCamps(response)
  }

  const handleFilterClient = (e: any) => {
    let value = e.value
    getClientList(value)
    setValue('companiaId', value)
    setError('companiaId', {})
  }

  const handleFilterSite = (e: any) => {
    let value = e.value
    getSiteList(value)
    setValue('clienteId', value)
    setError('clienteId', {})
  }

  const handleFilterCamp = (e: any) => {
    let value = e.value
    getCampList(value)
    setValue('siteId', value)
    setError('siteId', {})
  }

  const onSubmit = (dataForm: filterLaundryBatchModel) => {
    try {
      setIsSearching(true)
      const {fechaRegistro: inicio} = dataForm
      const data = {
        ...dataForm,
        fechaRegistro: inicio ? new Date(inicio) : '',
      }
      setFormValues(data)
      setFormValueLoading(true)
      setIsSearching(false)
    } catch (error) {
      setIsSearching(false)
    }
  }

  const handleResetForm = () => {
    reset()
    setClearTable(true)
  }

  useEffect(() => {
    getCompanyList()
    getTypeLaundryLoteList()
  }, [])
  return (
    <div className='p-6'>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className='m-2'>
          <div className='row'>
            <div className='col-sm-12 col-lg-3'>
              <SelectWrapper
                labelText='Compañía'
                name='companiaId'
                data={company}
                onChangeValue={handleFilterClient}
              />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <SelectWrapper
                labelText='Cliente'
                disabled={clients.length === 0}
                name='clienteId'
                data={clients}
                onChangeValue={handleFilterSite}
              />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <SelectWrapper
                labelText='Site'
                name='siteId'
                data={sites}
                disabled={sites.length === 0}
                onChangeValue={handleFilterCamp}
              />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <SelectWrapper
                labelText='Campamento'
                name='campamentoId'
                data={camps}
                disabled={camps.length === 0}
              />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <SelectWrapper
                labelText='Tipo de servicio'
                name='tipoLavado'
                data={typeLaundryOrderLote}
                required
              />
            </div>
          </div>
          <ButtonWrapper className='sdx-white-bg overflow-visible justify-content-end'>
            <Button label='Buscar' loading={searching} typeBtn='submit' />
            <Button
              label='Limpiar'
              disabled={!watch('companiaId')}
              onClick={() => handleResetForm()}
            />
            {currentTabItem.typeProcess === 'LAVADO' && currentTabItem.typeAdmin !== '' && (
              <>
                {currentTabItem.isStartLaundry && currentTabItem.detailRow?.estado !== 'OLF' && (
                  <Button
                    label='Inicio de Lavado'
                    // disabled={currentTabItem.isStartLaundry}
                    onClick={() => setShowModalStart(true)}
                  />
                )}
                {currentTabItem.isFinishLaundry && currentTabItem.detailRow?.estado !== 'OLF' && (
                  <Button
                    label='Fin de Lavado'
                    // disabled={currentTabItem.isFinishLaundry}
                    onClick={() => setShowModalFinish(true)}
                  />
                )}
              </>
            )}
            {currentTabItem.typeProcess === 'SALIDA' && !currentTabItem.isFinishOut && (
              <Button
                label='Finalizar Salida'
                // disabled={currentTabItem.isFinishOut}
                onClick={() => setShowModalOut(true)}
              />
            )}

            {currentTabItem.isCancel && (
              <Button
                label='Cancelar'
                // disabled={currentTabItem.isCancel}
                onClick={() => setShowModalCancel(true)}
              />
            )}
          </ButtonWrapper>
        </form>
      </FormProvider>
      <ModalFinishWash show={showModalFinish} setShow={setShowModalFinish} />
      <ModalStartWash show={showModalStart} setShow={setShowModalStart} />
      <ModalOut show={showModalOut} setShow={setShowModalOut} />
      <ModalCancel show={showModalCancel} setShow={setShowModalCancel} />
    </div>
  )
}
